import { RouteName } from "@/routes/routes.types";
import { UserAreaName } from "@/types/user.types";

type AreaRoutesMap = Partial<Record<UserAreaName, RouteName[]>>;

export const areaRoutesMap: AreaRoutesMap = {
    Agreements: ["agreements"],
    AGV_AlarmOverview: [],
    ENG_ConnectionPerformance: ["connectionPerformance"],
    ENG_LinerAdvice: ["TDSLinerAdvice"],
    ENG_LinerAdvice_PhaseTwo: [],
    ENG_MilkFlowProfile: ["mfpBimodality", "mfpPlotter"],
    FMS_Beta: ["farmScan"],
    FMS_Core: ["criticalAlarmsAnalysis", "customerDetail", "customers", "dashboard", "farmScan", "horizonInsights"],
    FMS_CareCheck: [],
    FMS_VectorLoading: ["vectorLoadingPerformance"],
    FMS_Dev: [],
    FMS_FieldAssist: [],
    FMS_FieldAssist_Overview: ["chameleon"],
    FMS_TeatDetectionSystemLinerAdvice: [],
    LIOBS_Core: [],
    ServiceManager_Core: [
        "attentionCustomers",
        "customerDetail",
        "dashboard",
        "devices",
        "customerDeviceDetail",
        "customerFarmCompressors",
        "profitability",
        "profitabilityCriticalAgreements",
        "serviceAreaSupport",
        "strategicOverview",
        "technicianDetail",
        "technicianDetailAbnormalPMTimes",
        "technicianDetailLongRepairs",
        "technicianDetailRepeatVisitRate",
    ],
    TSS_Core: [
        "customerDetail",
        "customerDeviceDetail",
        "customerDeviceReport",
        "customerFarmCompressors",
        "dashboard",
    ],
    TSS_MandatoryUpdates: ["mandatoryUpdates"],
    TSS_Parts: ["partDetail", "parts"],
    TSS_PreventiveMaintenanceOverdue: ["preventiveMaintenanceOverdue"],
    TSS_RepairsPerAstronaut: ["repairsPerAstronaut"],
    TSS_RepeatVisitCases: ["repeatVisitCases"],
    TSS_Technician_Core: ["dashboard"],
    TSS_TechnicianDetail: [
        "technicianDetail",
        "technicianDetailAbnormalPMTimes",
        "technicianDetailLongRepairs",
        "technicianDetailRepeatVisitRate",
        "technicians",
    ],
    TSS_TeamLead_Core: [
        "abnormalPreventiveMaintenanceTimes",
        "averageRepairTimes",
        "criticalAlarmsAnalysis",
        "longRepairs",
        "manHoursHigh",
        "productiveTime",
        "softwareVersionOverview",
    ],
    TSS_TeamLeadKPI: ["dashboard"],
    TSS_AstronautMax: [],
    Refactor_DataSourcesNewApproach: [],
    Refactor_JSBEDataSources: [],
    Horizon_Insights: ["horizonInsights"],
    ConnectionPerformanceDeviceIndex: [],
    PredictiveMaintenanceInsights: ["predictiveMaintenanceInsights"],
    VectorySystemFreeTimeKPI: [],
};

export const getAreaRoutes = (areas: UserAreaName[]): RouteName[] => {
    return areas.flatMap((area) => areaRoutesMap[area] ?? []);
};
